var render = function render(){
  var _vm$sessionDetail, _vm$sessionDetail$loc, _vm$sessionDetail2, _vm$sessionDetail2$lo, _vm$sessionDetail3, _vm$sessionDetail3$lo, _vm$sessionDetail4, _vm$sessionDetail4$lo, _vm$sessionDetail5, _vm$sessionDetail5$us, _vm$sessionDetail6, _vm$sessionDetail6$us, _vm$sessionDetail7, _vm$sessionDetail7$us, _vm$sessionDetail8, _vm$sessionDetail8$us, _vm$sessionDetail9, _vm$sessionDetail9$us, _vm$sessionDetail0, _vm$sessionDetail1, _vm$sessionDetail1$us, _vm$sessionDetail10, _vm$sessionDetail10$u, _vm$sessionDetail11, _vm$sessionDetail11$u, _vm$sessionDetail12, _vm$sessionDetail12$u, _vm$sessionDetail13, _vm$sessionDetail13$c, _vm$sessionDetail13$c2, _vm$sessionDetail14, _vm$sessionDetail14$c, _vm$sessionDetail14$c2, _vm$sessionDetail15, _vm$sessionDetail15$c, _vm$sessionDetail15$c2, _vm$sessionDetail16, _vm$sessionDetail16$c, _vm$sessionDetail16$c2, _vm$sessionDetail17, _vm$sessionDetail17$c, _vm$sessionDetail17$c2, _vm$sessionDetail18, _vm$sessionDetail18$c, _vm$sessionDetail18$c2, _vm$sessionDetail18$c3, _vm$sessionDetail19, _vm$sessionDetail19$c, _vm$sessionDetail19$c2, _vm$sessionDetail19$c3, _vm$sessionDetail20, _vm$sessionDetail20$c, _vm$sessionDetail20$c2, _vm$sessionDetail21, _vm$sessionDetail21$c, _vm$sessionDetail21$c2, _vm$sessionDetail22, _vm$sessionDetail22$c, _vm$sessionDetail22$c2, _vm$sessionDetail23, _vm$sessionDetail23$c, _vm$sessionDetail23$c2, _vm$sessionDetail24, _vm$sessionDetail24$c, _vm$sessionDetail24$c2, _vm$sessionDetail25, _vm$sessionDetail25$c, _vm$sessionDetail25$c2, _vm$sessionDetail26, _vm$sessionDetail26$c, _vm$sessionDetail26$c2, _vm$sessionDetail26$c3, _vm$sessionDetail27, _vm$sessionDetail27$c, _vm$sessionDetail27$c2, _vm$sessionDetail27$c3, _vm$sessionDetail28, _vm$sessionDetail28$c, _vm$sessionDetail28$c2, _vm$sessionDetail28$c3, _vm$sessionDetail29, _vm$sessionDetail29$c, _vm$sessionDetail29$c2, _vm$sessionDetail30, _vm$sessionDetail30$c, _vm$sessionDetail30$c2, _vm$sessionDetail31, _vm$sessionDetail31$c, _vm$sessionDetail31$c2, _vm$sessionDetail32, _vm$sessionDetail32$c, _vm$sessionDetail32$c2, _vm$sessionDetail33, _vm$sessionDetail33$c, _vm$sessionDetail33$c2, _vm$sessionDetail34, _vm$sessionDetail34$c, _vm$sessionDetail34$c2, _vm$sessionDetail35, _vm$sessionDetail35$c;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "darkGrey--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "px-5 pt-5"
  }, [_c('span', {
    staticClass: "subTitle"
  }, [_vm._v("Session Details")])])]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "mb-3 px-5 pt-5 pb-5 semi-bold"
  }, [_vm._v(" LOCATION "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showLocationHelp = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s('mdi-help-circle-outline')
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Country:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_c('flex-row', {
    attrs: {
      "gap": "4px"
    }
  }, [_c('flag', {
    attrs: {
      "code": (_vm$sessionDetail = _vm.sessionDetail) === null || _vm$sessionDetail === void 0 ? void 0 : (_vm$sessionDetail$loc = _vm$sessionDetail.location) === null || _vm$sessionDetail$loc === void 0 ? void 0 : _vm$sessionDetail$loc.country_code
    }
  }), _c('span', [_vm._v(_vm._s((_vm$sessionDetail2 = _vm.sessionDetail) === null || _vm$sessionDetail2 === void 0 ? void 0 : (_vm$sessionDetail2$lo = _vm$sessionDetail2.location) === null || _vm$sessionDetail2$lo === void 0 ? void 0 : _vm$sessionDetail2$lo.country) + " (" + _vm._s((_vm$sessionDetail3 = _vm.sessionDetail) === null || _vm$sessionDetail3 === void 0 ? void 0 : (_vm$sessionDetail3$lo = _vm$sessionDetail3.location) === null || _vm$sessionDetail3$lo === void 0 ? void 0 : _vm$sessionDetail3$lo.country_code) + ")")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" City:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail4 = _vm.sessionDetail) === null || _vm$sessionDetail4 === void 0 ? void 0 : (_vm$sessionDetail4$lo = _vm$sessionDetail4.location) === null || _vm$sessionDetail4$lo === void 0 ? void 0 : _vm$sessionDetail4$lo.city) + " ")])], 1)], 1), !_vm.fromOverview ? _c('v-col', {
    staticClass: "py-0 pt-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "mb-3 px-5 pt-5 pb-5 semi-bold"
  }, [_vm._v(" IDENTIFIERS "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showIdentifierHelp = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s('mdi-help-circle-outline')
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Identity:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [(_vm$sessionDetail5 = _vm.sessionDetail) !== null && _vm$sessionDetail5 !== void 0 && (_vm$sessionDetail5$us = _vm$sessionDetail5.user) !== null && _vm$sessionDetail5$us !== void 0 && _vm$sessionDetail5$us.identity ? _c('span', [_vm._v(_vm._s((_vm$sessionDetail6 = _vm.sessionDetail) === null || _vm$sessionDetail6 === void 0 ? void 0 : (_vm$sessionDetail6$us = _vm$sessionDetail6.user) === null || _vm$sessionDetail6$us === void 0 ? void 0 : _vm$sessionDetail6$us.identity))]) : _c('empty')], 1)], 1), (_vm$sessionDetail7 = _vm.sessionDetail) !== null && _vm$sessionDetail7 !== void 0 && (_vm$sessionDetail7$us = _vm$sessionDetail7.user) !== null && _vm$sessionDetail7$us !== void 0 && _vm$sessionDetail7$us.email ? _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v("Email:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [(_vm$sessionDetail8 = _vm.sessionDetail) !== null && _vm$sessionDetail8 !== void 0 && (_vm$sessionDetail8$us = _vm$sessionDetail8.user) !== null && _vm$sessionDetail8$us !== void 0 && _vm$sessionDetail8$us.email ? _c('span', [_vm._v(_vm._s(_vm.sessionDetail.user.email))]) : _c('empty')], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v("Name:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [(_vm$sessionDetail9 = _vm.sessionDetail) !== null && _vm$sessionDetail9 !== void 0 && (_vm$sessionDetail9$us = _vm$sessionDetail9.user) !== null && _vm$sessionDetail9$us !== void 0 && _vm$sessionDetail9$us.name || ((_vm$sessionDetail0 = _vm.sessionDetail) === null || _vm$sessionDetail0 === void 0 ? void 0 : _vm$sessionDetail0.anonymous_id) === ((_vm$sessionDetail1 = _vm.sessionDetail) === null || _vm$sessionDetail1 === void 0 ? void 0 : (_vm$sessionDetail1$us = _vm$sessionDetail1.user) === null || _vm$sessionDetail1$us === void 0 ? void 0 : _vm$sessionDetail1$us.identity) ? _c('MaxText', {
    attrs: {
      "text": ((_vm$sessionDetail10 = _vm.sessionDetail) === null || _vm$sessionDetail10 === void 0 ? void 0 : (_vm$sessionDetail10$u = _vm$sessionDetail10.user) === null || _vm$sessionDetail10$u === void 0 ? void 0 : _vm$sessionDetail10$u.name) || 'Anonymous',
      "max": "30"
    }
  }) : _c('empty')], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items"
  }, [(_vm$sessionDetail11 = _vm.sessionDetail) !== null && _vm$sessionDetail11 !== void 0 && (_vm$sessionDetail11$u = _vm$sessionDetail11.user) !== null && _vm$sessionDetail11$u !== void 0 && _vm$sessionDetail11$u.traits && Object.keys((_vm$sessionDetail12 = _vm.sessionDetail) === null || _vm$sessionDetail12 === void 0 ? void 0 : (_vm$sessionDetail12$u = _vm$sessionDetail12.user) === null || _vm$sessionDetail12$u === void 0 ? void 0 : _vm$sessionDetail12$u.traits).length ? _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "mb-3 px-5 pt-5 pb-5 semi-bold"
  }, [_vm._v("TRAITS")]), _vm._l(Object.keys(_vm.otherAttributes), function (item, index) {
    return _c('v-row', {
      key: index,
      staticClass: "projectDetails-items pt-5 px-5"
    }, [_c('v-col', {
      staticClass: "pa-0 px-5 text-capitalize",
      attrs: {
        "cols": "5"
      }
    }, [_vm._v(_vm._s(item) + ":")]), _c('v-col', {
      staticClass: "semi-bold ma-0 pa-0",
      attrs: {
        "cols": "7"
      }
    }, [_vm._v(" " + _vm._s(_vm.otherAttributes[item]) + " ")])], 1);
  })], 2) : _vm._e()], 1)], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "mb-3 px-5 pb-5 semi-bold"
  }, [_vm._v(" APP "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showAppHelp = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s('mdi-help-circle-outline')
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Name:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail13 = _vm.sessionDetail) === null || _vm$sessionDetail13 === void 0 ? void 0 : (_vm$sessionDetail13$c = _vm$sessionDetail13.context) === null || _vm$sessionDetail13$c === void 0 ? void 0 : (_vm$sessionDetail13$c2 = _vm$sessionDetail13$c.app) === null || _vm$sessionDetail13$c2 === void 0 ? void 0 : _vm$sessionDetail13$c2.name) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Package:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail14 = _vm.sessionDetail) === null || _vm$sessionDetail14 === void 0 ? void 0 : (_vm$sessionDetail14$c = _vm$sessionDetail14.context) === null || _vm$sessionDetail14$c === void 0 ? void 0 : (_vm$sessionDetail14$c2 = _vm$sessionDetail14$c.app) === null || _vm$sessionDetail14$c2 === void 0 ? void 0 : _vm$sessionDetail14$c2.package) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Version:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" v" + _vm._s((_vm$sessionDetail15 = _vm.sessionDetail) === null || _vm$sessionDetail15 === void 0 ? void 0 : (_vm$sessionDetail15$c = _vm$sessionDetail15.context) === null || _vm$sessionDetail15$c === void 0 ? void 0 : (_vm$sessionDetail15$c2 = _vm$sessionDetail15$c.app) === null || _vm$sessionDetail15$c2 === void 0 ? void 0 : _vm$sessionDetail15$c2.version) + " (" + _vm._s((_vm$sessionDetail16 = _vm.sessionDetail) === null || _vm$sessionDetail16 === void 0 ? void 0 : (_vm$sessionDetail16$c = _vm$sessionDetail16.context) === null || _vm$sessionDetail16$c === void 0 ? void 0 : (_vm$sessionDetail16$c2 = _vm$sessionDetail16$c.app) === null || _vm$sessionDetail16$c2 === void 0 ? void 0 : _vm$sessionDetail16$c2.version_code) + ") ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items mb-1 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Environment:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail17 = _vm.sessionDetail) === null || _vm$sessionDetail17 === void 0 ? void 0 : (_vm$sessionDetail17$c = _vm$sessionDetail17.context) === null || _vm$sessionDetail17$c === void 0 ? void 0 : (_vm$sessionDetail17$c2 = _vm$sessionDetail17$c.app) === null || _vm$sessionDetail17$c2 === void 0 ? void 0 : _vm$sessionDetail17$c2.environment) + " ")])], 1)], 1), !_vm.fromOverview ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "justify-space-between"
  }, [_c('div', {
    staticClass: "mb-3 px-5 pt-5 pb-5 semi-bold"
  }, [_vm._v(" DEVICE "), _c('div', {
    staticClass: "float-right primary--text regular-font font14 cursor-pointer",
    on: {
      "click": _vm.toggleDevices
    }
  }, [_vm._v(" " + _vm._s(_vm.showDeviceExtraAttributes ? "View less" : "View more") + " ")])])]), _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" OS:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": ((_vm$sessionDetail18 = _vm.sessionDetail) === null || _vm$sessionDetail18 === void 0 ? void 0 : (_vm$sessionDetail18$c = _vm$sessionDetail18.context) === null || _vm$sessionDetail18$c === void 0 ? void 0 : (_vm$sessionDetail18$c2 = _vm$sessionDetail18$c.device) === null || _vm$sessionDetail18$c2 === void 0 ? void 0 : (_vm$sessionDetail18$c3 = _vm$sessionDetail18$c2.os) === null || _vm$sessionDetail18$c3 === void 0 ? void 0 : _vm$sessionDetail18$c3.name) === 'android' ? 'green' : 'grey',
      "left": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(((_vm$sessionDetail19 = _vm.sessionDetail) === null || _vm$sessionDetail19 === void 0 ? void 0 : (_vm$sessionDetail19$c = _vm$sessionDetail19.context) === null || _vm$sessionDetail19$c === void 0 ? void 0 : (_vm$sessionDetail19$c2 = _vm$sessionDetail19$c.device) === null || _vm$sessionDetail19$c2 === void 0 ? void 0 : (_vm$sessionDetail19$c3 = _vm$sessionDetail19$c2.os) === null || _vm$sessionDetail19$c3 === void 0 ? void 0 : _vm$sessionDetail19$c3.name) === "android" ? "mdi-android" : "mdi-apple") + " ")])], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Model:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail20 = _vm.sessionDetail) === null || _vm$sessionDetail20 === void 0 ? void 0 : (_vm$sessionDetail20$c = _vm$sessionDetail20.context) === null || _vm$sessionDetail20$c === void 0 ? void 0 : (_vm$sessionDetail20$c2 = _vm$sessionDetail20$c.device) === null || _vm$sessionDetail20$c2 === void 0 ? void 0 : _vm$sessionDetail20$c2.model) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Type:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail21 = _vm.sessionDetail) === null || _vm$sessionDetail21 === void 0 ? void 0 : (_vm$sessionDetail21$c = _vm$sessionDetail21.context) === null || _vm$sessionDetail21$c === void 0 ? void 0 : (_vm$sessionDetail21$c2 = _vm$sessionDetail21$c.device) === null || _vm$sessionDetail21$c2 === void 0 ? void 0 : _vm$sessionDetail21$c2.type) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Timezone:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail22 = _vm.sessionDetail) === null || _vm$sessionDetail22 === void 0 ? void 0 : (_vm$sessionDetail22$c = _vm$sessionDetail22.context) === null || _vm$sessionDetail22$c === void 0 ? void 0 : (_vm$sessionDetail22$c2 = _vm$sessionDetail22$c.device) === null || _vm$sessionDetail22$c2 === void 0 ? void 0 : _vm$sessionDetail22$c2.timezone) + " ")])], 1), _vm.showDeviceExtraAttributes ? [_c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" RAM:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatBytes((((_vm$sessionDetail23 = _vm.sessionDetail) === null || _vm$sessionDetail23 === void 0 ? void 0 : (_vm$sessionDetail23$c = _vm$sessionDetail23.context) === null || _vm$sessionDetail23$c === void 0 ? void 0 : (_vm$sessionDetail23$c2 = _vm$sessionDetail23$c.device) === null || _vm$sessionDetail23$c2 === void 0 ? void 0 : _vm$sessionDetail23$c2.ram) || 0) / 1000)) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" CPU:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail24 = _vm.sessionDetail) === null || _vm$sessionDetail24 === void 0 ? void 0 : (_vm$sessionDetail24$c = _vm$sessionDetail24.context) === null || _vm$sessionDetail24$c === void 0 ? void 0 : (_vm$sessionDetail24$c2 = _vm$sessionDetail24$c.device) === null || _vm$sessionDetail24$c2 === void 0 ? void 0 : _vm$sessionDetail24$c2.cores) + " Cores ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Locale:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail25 = _vm.sessionDetail) === null || _vm$sessionDetail25 === void 0 ? void 0 : (_vm$sessionDetail25$c = _vm$sessionDetail25.context) === null || _vm$sessionDetail25$c === void 0 ? void 0 : (_vm$sessionDetail25$c2 = _vm$sessionDetail25$c.device) === null || _vm$sessionDetail25$c2 === void 0 ? void 0 : _vm$sessionDetail25$c2.locale) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Screen:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail26 = _vm.sessionDetail) === null || _vm$sessionDetail26 === void 0 ? void 0 : (_vm$sessionDetail26$c = _vm$sessionDetail26.context) === null || _vm$sessionDetail26$c === void 0 ? void 0 : (_vm$sessionDetail26$c2 = _vm$sessionDetail26$c.device) === null || _vm$sessionDetail26$c2 === void 0 ? void 0 : (_vm$sessionDetail26$c3 = _vm$sessionDetail26$c2.screen) === null || _vm$sessionDetail26$c3 === void 0 ? void 0 : _vm$sessionDetail26$c3.width) + "w, " + _vm._s((_vm$sessionDetail27 = _vm.sessionDetail) === null || _vm$sessionDetail27 === void 0 ? void 0 : (_vm$sessionDetail27$c = _vm$sessionDetail27.context) === null || _vm$sessionDetail27$c === void 0 ? void 0 : (_vm$sessionDetail27$c2 = _vm$sessionDetail27$c.device) === null || _vm$sessionDetail27$c2 === void 0 ? void 0 : (_vm$sessionDetail27$c3 = _vm$sessionDetail27$c2.screen) === null || _vm$sessionDetail27$c3 === void 0 ? void 0 : _vm$sessionDetail27$c3.height) + "h, " + _vm._s((_vm$sessionDetail28 = _vm.sessionDetail) === null || _vm$sessionDetail28 === void 0 ? void 0 : (_vm$sessionDetail28$c = _vm$sessionDetail28.context) === null || _vm$sessionDetail28$c === void 0 ? void 0 : (_vm$sessionDetail28$c2 = _vm$sessionDetail28$c.device) === null || _vm$sessionDetail28$c2 === void 0 ? void 0 : (_vm$sessionDetail28$c3 = _vm$sessionDetail28$c2.screen) === null || _vm$sessionDetail28$c3 === void 0 ? void 0 : _vm$sessionDetail28$c3.density) + "d ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Simulator:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": (_vm$sessionDetail29 = _vm.sessionDetail) !== null && _vm$sessionDetail29 !== void 0 && (_vm$sessionDetail29$c = _vm$sessionDetail29.context) !== null && _vm$sessionDetail29$c !== void 0 && (_vm$sessionDetail29$c2 = _vm$sessionDetail29$c.device) !== null && _vm$sessionDetail29$c2 !== void 0 && _vm$sessionDetail29$c2.simulator ? 'success' : 'error'
    },
    domProps: {
      "textContent": _vm._s((_vm$sessionDetail30 = _vm.sessionDetail) !== null && _vm$sessionDetail30 !== void 0 && (_vm$sessionDetail30$c = _vm$sessionDetail30.context) !== null && _vm$sessionDetail30$c !== void 0 && (_vm$sessionDetail30$c2 = _vm$sessionDetail30$c.device) !== null && _vm$sessionDetail30$c2 !== void 0 && _vm$sessionDetail30$c2.simulator ? 'mdi-check' : 'mdi-close')
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" UUID:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail31 = _vm.sessionDetail) === null || _vm$sessionDetail31 === void 0 ? void 0 : (_vm$sessionDetail31$c = _vm$sessionDetail31.context) === null || _vm$sessionDetail31$c === void 0 ? void 0 : (_vm$sessionDetail31$c2 = _vm$sessionDetail31$c.device) === null || _vm$sessionDetail31$c2 === void 0 ? void 0 : _vm$sessionDetail31$c2.uuid) + " ")])], 1)] : _vm._e()], 2), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _c('v-col', {
    attrs: {
      "cols": _vm.fromOverview ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "mb-3 px-5 pb-5 semi-bold"
  }, [_vm._v("SDK")]), _c('v-row', {
    staticClass: "projectDetails-items pt-5 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Name:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail32 = _vm.sessionDetail) === null || _vm$sessionDetail32 === void 0 ? void 0 : (_vm$sessionDetail32$c = _vm$sessionDetail32.context) === null || _vm$sessionDetail32$c === void 0 ? void 0 : (_vm$sessionDetail32$c2 = _vm$sessionDetail32$c.sdk) === null || _vm$sessionDetail32$c2 === void 0 ? void 0 : _vm$sessionDetail32$c2.name) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Version:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail33 = _vm.sessionDetail) === null || _vm$sessionDetail33 === void 0 ? void 0 : (_vm$sessionDetail33$c = _vm$sessionDetail33.context) === null || _vm$sessionDetail33$c === void 0 ? void 0 : (_vm$sessionDetail33$c2 = _vm$sessionDetail33$c.sdk) === null || _vm$sessionDetail33$c2 === void 0 ? void 0 : _vm$sessionDetail33$c2.version) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Version Code:")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail34 = _vm.sessionDetail) === null || _vm$sessionDetail34 === void 0 ? void 0 : (_vm$sessionDetail34$c = _vm$sessionDetail34.context) === null || _vm$sessionDetail34$c === void 0 ? void 0 : (_vm$sessionDetail34$c2 = _vm$sessionDetail34$c.sdk) === null || _vm$sessionDetail34$c2 === void 0 ? void 0 : _vm$sessionDetail34$c2.version_code) + " ")])], 1), _c('v-row', {
    staticClass: "projectDetails-items mb-1 px-5"
  }, [_c('v-col', {
    staticClass: "pa-0 px-5",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" User Agent")]), _c('v-col', {
    staticClass: "semi-bold ma-0 pa-0",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s((_vm$sessionDetail35 = _vm.sessionDetail) === null || _vm$sessionDetail35 === void 0 ? void 0 : (_vm$sessionDetail35$c = _vm$sessionDetail35.context) === null || _vm$sessionDetail35$c === void 0 ? void 0 : _vm$sessionDetail35$c.user_agent) + " ")])], 1)], 1), _c('Modal', {
    attrs: {
      "closeable": ""
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', {
          staticClass: "headline text-center"
        }, [_vm._v("App Information Details")]), _c('v-card-text', {
          staticClass: "font-14"
        }, [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('p', [_c('strong', [_vm._v("Name:")]), _vm._v(" The unique name of your app as registered in the SDK. "), _c('br'), _vm._v("Example: "), _c('em', [_vm._v("Example App")]), _vm._v(". ")]), _c('p', [_c('strong', [_vm._v("Package (Bundle ID):")]), _vm._v(" The Bundle Identifier for your iOS app, usually in reverse domain name format. "), _c('br'), _vm._v("Example: "), _c('em', [_vm._v("testapp.io.example-app")]), _vm._v(". ")]), _c('p', [_c('strong', [_vm._v("Version (Build Number):")]), _vm._v(" The Build Number of your app, representing a specific iteration of your app. "), _c('br'), _vm._v("Example: "), _c('em', [_vm._v("v1.0 (106)")]), _vm._v(" where 106 is the Build Number. ")]), _c('p', [_c('strong', [_vm._v("Environment:")]), _vm._v(" Set during the setup function and indicates the app's current running environment. Options include "), _c('code', [_vm._v("dev")]), _vm._v(", "), _c('code', [_vm._v("staging")]), _vm._v(", and "), _c('code', [_vm._v("production")]), _vm._v(". "), _c('br'), _vm._v("Default: "), _c('em', [_vm._v("dev")])]), _c('p', [_vm._v(" These details are vital for accurately tracking and managing different versions and configurations of your app during development, testing, and production phases. ")])])], 1)], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showAppHelp,
      callback: function callback($$v) {
        _vm.showAppHelp = $$v;
      },
      expression: "showAppHelp"
    }
  }), _c('Modal', {
    attrs: {
      "width": _vm.$vuetify.breakpoint.mdAndUp ? '800' : '',
      "closeable": "",
      "fullscreen": _vm.$vuetify.breakpoint.mdAndDown
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', {
          staticClass: "headline text-center"
        }, [_vm._v("User Identification")]), _c('v-card-text', {
          staticClass: "font-16"
        }, [_c('session-code-example')], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showIdentifierHelp,
      callback: function callback($$v) {
        _vm.showIdentifierHelp = $$v;
      },
      expression: "showIdentifierHelp"
    }
  }), _c('Modal', {
    attrs: {
      "closeable": ""
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', {
          staticClass: "headline text-center"
        }, [_vm._v("Tester Location via IP Address")]), _c('v-card-text', {
          staticClass: "font-14"
        }, [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('p', [_vm._v(" Our platform determines and displays each tester's country and city based on their IP address. This helps developers understand geographical usage patterns and tailor their applications accordingly. ")]), _c('p', [_vm._v(" However, it's important to note that this method isn't always precise. IP address locations can be affected by factors like VPNs, proxy servers, and mobile network changes. While generally reliable, developers should be aware of these potential inaccuracies. ")])])], 1)], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showLocationHelp,
      callback: function callback($$v) {
        _vm.showLocationHelp = $$v;
      },
      expression: "showLocationHelp"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }